import { RegistrationError, resendClassLink } from "../api/registrations";

/** Knappen hålls låst en stund efter ett skickat mejl, så att den inte går att spamklicka. */
const COOLDOWN_SECONDS = 60;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function initResendLink(root: HTMLElement): void {
  const form = root.querySelector<HTMLFormElement>("form");
  const email = root.querySelector<HTMLInputElement>('input[name="email"]');
  const website = root.querySelector<HTMLInputElement>('input[name="website"]');
  const button = root.querySelector<HTMLButtonElement>('button[type="submit"]');
  const status = root.querySelector<HTMLElement>("[data-resend-status]");

  if (!form || !email || !button || !status) {
    return;
  }

  const buttonText = button.textContent ?? "";
  let busy = false;

  const lock = (seconds: number): void => {
    button.disabled = true;
    let remaining = seconds;
    button.textContent = `${buttonText} (${remaining})`;

    const timer = window.setInterval(() => {
      remaining--;
      if (remaining <= 0) {
        window.clearInterval(timer);
        button.disabled = false;
        button.textContent = buttonText;
        busy = false;
        return;
      }
      button.textContent = `${buttonText} (${remaining})`;
    }, 1000);
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    if (busy) {
      return;
    }

    const value = email.value.trim();
    const field = email.closest(".breaks-field");

    if (!EMAIL_PATTERN.test(value)) {
      status.textContent = "Ange en giltig e-postadress.";
      if (field) {
        field.classList.add("breaks-field--invalid");
      }
      email.focus();
      return;
    }

    if (field) {
      field.classList.remove("breaks-field--invalid");
    }

    busy = true;
    button.disabled = true;
    status.textContent = "Skickar…";

    try {
      status.textContent = await resendClassLink(value, website?.value ?? "");
      lock(COOLDOWN_SECONDS);
    } catch (error) {
      status.textContent = error instanceof RegistrationError
          ? error.message
          : "Länken kunde inte skickas. Försök igen senare.";
      
      if (error instanceof RegistrationError && error.status === 429) {
        lock(COOLDOWN_SECONDS);
      } else {
        busy = false;
        button.disabled = false;
      }
    }
  });
}

export function initResendLinks(): void {
  document
    .querySelectorAll<HTMLElement>("[data-breaks-resend-link]")
    .forEach(initResendLink);
}
